import ProjectTeamMemberModule from './member.module'

export default ProjectTeamMemberModule
